import { render, staticRenderFns } from "./TacLookupDashboard.vue?vue&type=template&id=f04440dc&scoped=true"
import script from "./TacLookupDashboard.vue?vue&type=script&lang=js"
export * from "./TacLookupDashboard.vue?vue&type=script&lang=js"
import style0 from "./TacLookupDashboard.vue?vue&type=style&index=0&id=f04440dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04440dc",
  null
  
)

export default component.exports